import axios from 'axios'
import { getCookie, removeCookie } from './cookie'
// eslint-disable-next-line import/no-cycle

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
})

http.interceptors.request.use((config) => {
  // store.commit('formLoading', true)
  // TODO: ADD token to all requests
  config.headers.Authorization = `Bearer ${getCookie('token')}`
  return config
}, (err) => {
  return Promise.reject(err)
})

http.interceptors.response.use(res => {
  const { data } = res
  // store.commit('formLoading', false)
  if (!data) return false
  if (data.code >= 400 && data.code <= 500) {
    console.log('Error status code: ', data.code)
  }
  return res
}, (err) => {
  // store.commit('formLoading', false)
  if (err.response.status === 401) {
    removeCookie('token')
    removeCookie('tenantId')
    removeCookie('userId')
    window.location.reload()
    console.log('Redirect because user is not logged in')
  }
  if (!err.response) {
    console.log('message', { type: 'error', text: 'Problema com o servidor. Tente novamente.' })
    return Promise.reject(new Error('Problema com servidor'))
  }
  return Promise.reject(err)
})

export default http



// WEBPACK FOOTER //
// ./src/helpers/http.js